import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import { useSelector } from 'react-redux';
import CreateForm from './create';

export const MonitoringAlarmsList = ({ history }) => {
  const { [ACTIONS_TYPES.MONITORING.ALARM.GET_ALL]: monitoringAlarms = [] } = useSelector((e) => e);

  useEffect(() => {
    actions.monitoring.alarm.getAll();
  }, []);

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.MONITORING_ALARMS}
      isStrap={false}
    >
      <Shared.widgets.Section
        sectionTitle="Alarms"
        itemIcon="bell"
        items={monitoringAlarms}
        setItemTitle={(e) => e?.properties?.name}
        setItemDetails={(e) => <Shared.utilities.Status state={e?.properties?.state} />}
        itemOnClick={(e) => history.push(ROUTE.DASHBOARD.MONITORING_ALARM.path.replace(':id', e?.id))}
        createForm={<CreateForm />}
        createActionType={ACTIONS_TYPES.MONITORING.ALARM.CREATE}
      />
    </Shared.widgets.Page>
  );
};
